/**
 * Renders a lead's resolved cycle for display: `"Enero - Junio 2027 (2026-2)"`.
 *
 * Both halves are shown on purpose. The label is what a human reads; the key is
 * what the agent actually captured and what `capture_qualification` enumerates,
 * and the two do not always line up intuitively — a school-year convention can
 * make `2026-2` mean January–June 2027. The test panel previously showed the
 * label under a `cycleKey` heading, which read as a mislabeled value.
 */
export function formatCycle(key: string | null, label: string | null): string | null {
  if (!label) return key;
  return key ? `${label} (${key})` : label;
}
